<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>

      <div class="main-div">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <!--SID1045 Body Part-->
              <template>
                <el-container class="SID1045__inquiryCondition">
                  <div class="SID1045__Container">
                    <!-- Breadcrumb section -->
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧) </el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '1035' }">原文利用実績照会設定</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '' }">原文利用頻度照会</el-breadcrumb-item>
                      <!-- <el-breadcrumb-item :to="{ path: '' }">照会結果</el-breadcrumb-item> -->
                    </el-breadcrumb>
                    <div>
                      <span class="Inquiry__condition">照会条件</span>
                    </div>
                    <div>
                      <el-divider class="result-main-divider"></el-divider>
                    </div>
                    <el-container>
                      <div class="resultDiv">
                        <el-form class="div-result" label-width="auto">
                          <el-form-item label="集計対象 ">
                            <span>{{ articleName }}</span>
                          </el-form-item>
                          <el-form-item label="集計期間">
                            <span>{{ getPeriodResult1045 }}</span>
                          </el-form-item>
                          <el-form-item label="利用件数">
                            {{ UserreadCount }}
                          </el-form-item>
                          <el-form-item label="表示件数">
                            <span>{{ getTableDisaplyCount1045 }}</span>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-container>

                    <el-container>
                      <el-table
                        :data="getTableResult1045"
                        border
                        style="width: 100%"
                        class="table-result"
                      >
                        <el-table-column prop="num" label="No." width="80"></el-table-column>
                        <el-table-column prop="media_name" label="媒体情報" min-width="100"></el-table-column>
                        <el-table-column prop="read_count" label="利用件数" min-width="100"></el-table-column>
                        <el-table-column prop="issue_date" label="発行年月日" min-width="100"></el-table-column>
                        <el-table-column prop="issue_type" label="朝夕刊" min-width="80"></el-table-column>
                        <el-table-column prop="frame_no" label="面数" min-width="60"></el-table-column>
                        <el-table-column prop="title" label="見出し" min-width="350">
                        <!-- Change by Ck for Backlog ID :1608 removed el link -->
                          <!-- <template slot-scope="scope" >
                            <el-link type="primary"  class="ArticleLink" :underline="false" style="text-align:left!important;">
                              <span v-html="scope.row.title"></span>
                            </el-link> 
                          </template> -->
                        </el-table-column>
                      </el-table>
                    </el-container>
                    <!-- Change by Ck for Backlog ID :1608 -->
                    <!-- <div class="spanSpace">
                      <span>・当日利用分も出力件数に含まれております。</span>
                    </div> -->
                    <el-row class="ButtonDiv">
                      <el-button type="primary" @click="csvdownload()" plain>CSV出力</el-button>
                      <el-button type="info" @click="gofrom1045" plain>戻る</el-button>
                    </el-row>
                  </div>
                </el-container>
              </template>
              <!--SID1045 Body Part End-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>

      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import json from '../../components/config.json'
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import router from "../../router";
export default {
  name: "app",
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane
    // ElTableDraggable
  },
  data() {
    return {
      multipleSelection: [],
      text: "",
      dummy: "",
      Selected: [],
      articleName:"",
      SearchInquiry1045:[],
      UserreadCount:""
    };
  },
  computed: {
    ...mapGetters("situation1045", [
      "getTableResult1045",
      "getPeriodResult1045",
      "getallArticles",
      "getFormMethod",
      "getFormPeriod",
      "getFormTitle",
      "getFormCondition",
      "getTableDisaplyCount1045",
			"getCsvDownloadErrStatus",
			"getCsvDownloadErrmsgDetail"
    ])
  },
  methods: {
    gofrom1045() {
      this.$LogButtonEvent("1045","Return");
      this.$LogMethodIN("1045","gofrom1045");
      router.push({ name: "1035", params: {fromSID1045:'1'}});
      this.$LogMethodOut("1045","gofrom1045");
    },
    csvdownload(){
      this.$LogButtonEvent("1045","CsvOutput");
      this.$LogMethodIN("1045","csvdownload");
			this.$confirm(json["1045_CSV_download_message"], json["1045_CSV_download_title"], {
				showCancelButton: true,		
				confirmButtonText: 'OK',
				cancelButtonText: 'キャンセル',
				customClass:'increase-width',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {              										      			
						done(); 
            this.$store.dispatch('communication1045/downloadUsageFrquencyList',this.SearchInquiry1045)
            .then(() => {
							//After the Ajax call finished check if status is error for showing alert
							var status = this.getCsvDownloadErrStatus;
							var msgdetail = this.getCsvDownloadErrmsgDetail;
							if(status == "1")
							{
								this.$alert(msgdetail,"更新", {  confirmButtonText: 'OK',  })
							}
							else
							{
								//console.log("else");
							}
						});
					} 
					else 
					{				
						done();
					}
				}
      });
       this.$LogMethodOut("1045","csvdownload");
		}
  },
  mounted() {
       var articleType =this.$route.params.SearchInquiry.data_section;
       this.UserreadCount=this.$route.params.SearchInquiry.read_count;
          this.SearchInquiry1045 ={
            data_section: this.$route.params.SearchInquiry.data_section,
            start_date:this.$route.params.SearchInquiry.start_date,
            end_date:this.$route.params.SearchInquiry.end_date,
            read_count:this.$route.params.SearchInquiry.read_count,
            items_count:this.$route.params.SearchInquiry.items_count
            
          };
       //var articleName='';
       if(articleType == 0){
        this.articleName="全記事";
       }
       else if(articleType == 1){
        this.articleName="EL記事";
       }
       else{
        this.articleName="日経記事";
       }

  },
   beforeCreate(){
     //For the screen Title
     document.title = "照会結果";
		//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
  },
 
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
@import "1045.css";
</style>